import { render, staticRenderFns } from "./ICChanPinXinXi.vue?vue&type=template&id=4ed6ed78&scoped=true"
import script from "./ICChanPinXinXi.vue?vue&type=script&lang=js"
export * from "./ICChanPinXinXi.vue?vue&type=script&lang=js"
import style1 from "./ICChanPinXinXi.vue?vue&type=style&index=1&id=4ed6ed78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6ed78",
  null
  
)

export default component.exports